import {inject, Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {ConnectApiService} from './connect-api.service';

export interface ConnectInternalAiToolReadiness {
  runtimeReady: boolean;
  allowlisted: boolean;
  signerConfigured: boolean;
  clientAllowed: boolean;
  replayReady: boolean;
  idempotencyReady: boolean;
  blockingReasons: string[];
}

export interface ConnectInternalAiTool {
  operationId: string;
  toolName: string;
  workflowId: string;
  workflowName: string;
  workflowVersion: string;
  specHash?: string;
  description: string;
  triggerType?: string;
  tags: string[];
  inputSchema?: string;
  readiness: ConnectInternalAiToolReadiness;
}

@Injectable({
  providedIn: 'root'
})
export class ConnectInternalAiToolsService {
  private readonly api = inject(ConnectApiService);

  listTools(params?: { serviceId?: string; signatureVersion?: string }): Observable<ConnectInternalAiTool[]> {
    const query: string[] = [];
    if (params?.serviceId) {
      query.push(`service_id=${encodeURIComponent(params.serviceId)}`);
    }
    if (params?.signatureVersion) {
      query.push(`signature_version=${encodeURIComponent(params.signatureVersion)}`);
    }

    const suffix = query.length > 0 ? `?${query.join('&')}` : '';
    return this.api.get<{ items?: ConnectInternalAiTool[] }>(
      `/api/v1/internal-ai/tools${suffix}`,
      { scopeTenant: false }
    ).pipe(
      map(response => response?.items ?? [])
    );
  }
}
